const inputValidator = () => {
  const validateFieldName = field => field && (field.length >= 2 && field.length <= 100);
  const validateFieldEmail = field => field && !!field.match(/.+@.+\..+/i);
  const validateFields = fields => fields.every(([value, fn]) => fn(value));

  return {
    validateFieldName,
    validateFieldEmail,
    validateFields
  };
};

export default inputValidator;
